import { PromptRow } from './PromptRow'
import type { ProjectPhase, Prompt } from '@/types'

interface PromptPhaseSectionProps {
  projectPhase: ProjectPhase
  prompts: Prompt[]
  onDelete: (prompt: Prompt) => void
}

const projectPhaseTitleClass = "text-base font-bold leading-[150%] tracking-[0.015em] text-foreground"
const projectPhaseCountClass = "text-base font-normal leading-[150%] tracking-[0.015em] text-card-foreground"

export function PromptPhaseSection({ projectPhase, prompts, onDelete }: PromptPhaseSectionProps) {
  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        <div
          className="h-2.5 w-2.5 rounded-full"
          style={{ backgroundColor: projectPhase.displayColor }}
        />
        <span className={projectPhaseTitleClass}>{projectPhase.name}</span>
        <span className={projectPhaseCountClass}>({prompts.length})</span>
      </div>
      {prompts.length > 0 ? (
        <div className="space-y-3">
          {prompts.map((prompt) => (
            <PromptRow
              key={prompt.id}
              prompt={prompt}
              onDelete={onDelete}
            />
          ))}
        </div>
      ) : (
        <div className="px-4 py-6 text-center text-sm text-muted-foreground">
          No prompts in this phase
        </div>
      )}
    </div>
  )
}
